import { useEffect } from 'react';

// The Hourly Performance page was replaced by the Command Center dashboard,
// a standalone Vite app served by the backend at /command-center/.
const CommandCenterRedirect = () => {
    useEffect(() => {
        window.location.replace('/command-center/');
    }, []);

    return (
        <div className="flex items-center justify-center h-full py-20 text-gray-500">
            Opening Command Center…
        </div>
    );
};

export default CommandCenterRedirect;
